var map = {
	"./pic1.jpg": 40,
	"./pic2.jpg": 41,
	"./pic3.jpg": 42,
	"./pic4.jpg": 43,
	"./pic5.jpg": 44,
	"./pic6.jpg": 45,
	"./pic7.jpg": 46,
	"./pic8.jpg": 47,
	"./pic9.jpg": 48,
	"./player.jpg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;